import { useEffect, useState } from 'react'

// react-modal locks page scroll with a reference-counted class on <body>. A modal that mounts
// already open gets opened twice under React 18 StrictMode, so closing it removes only one
// reference and the page can no longer scroll. Mounting closed and opening on the next render
// keeps the count balanced, wherever the modal is used.
const useOpenAfterMount = (isOpen) => {
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)
	}, [])

	return mounted && Boolean(isOpen)
}

export default useOpenAfterMount
